import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'pb0102',
    ecrans: ['00-2']
});